import { Type, Expose } from 'class-transformer';
import { IsNumber,IsString } from 'class-validator';

class SaleOrg {
  constructor() {
    this.id = 0;
    this.name = "";
    this.target = 0;
    this.plan = 0;
    this.actual = 0;
  }

  @IsNumber()
  @Expose({ name: 'subContactId' })
  id: number;
  
  @IsString()
  @Expose({ name: 'employeeName' })
  name: string;

  @IsNumber()
  @Expose({ name: 'targetQty' })
  target: number;

  @IsNumber()
  @Expose({ name: 'planQty' })
  plan: number;

  @IsNumber()
  @Expose({ name: 'actualQty' })
  actual: number;
}

export default SaleOrg;
